import { createFileRoute } from "@tanstack/react-router";
import { RoutedInformation } from "@/components/RoutedInformation";

export const Route = createFileRoute("/privacy")({
  component: () => <RoutedInformation section="privacy" />,
});
